import { render, staticRenderFns } from "./ComfortLevelComponent.vue?vue&type=template&id=70be8a40"
import script from "./ComfortLevelComponent.vue?vue&type=script&lang=js"
export * from "./ComfortLevelComponent.vue?vue&type=script&lang=js"
import style0 from "./ComfortLevelComponent.vue?vue&type=style&index=0&id=70be8a40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports